import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn,BeforeInsert, BeforeUpdate} from "typeorm";
import * as bcrypt from 'bcrypt'; 
import { RolesEntity } from "../roles/roles.entity";
import { HierarchyEntity } from "../hierarchy/hierarchy.entity";
import { ProfileEntity } from "../profile/profile.entity";
import { PostActivityEntity } from "../post-activity/post-activity.entity";
import { PostFilesEntity } from "../post-files/post-files.entity";
import { CommmentsEntity } from "../comments/comments.entity";
import { PostEntity } from "../post/post.entity";
import { PollEntity } from "../poll/poll.entity";
import { ReportEntity } from "../report/report.entity";
import { EventsEntity } from "../event/event.entity";
import { EventDetailsEntity } from "../event-details/event-details.entity";
import { PollVotingEntity } from "../poll/poll-voting.entity";
import { PostPointsEntity } from "../post/post-points.entity";
import { WelfareEntity } from "../welfare/welfare.entity";
import { RepresentationEntity } from "../representation/representation.entity";
import { WelfareStatusEntity } from "../welfare/welfare-status.entity";
import { PostActivitySharedEntity } from "../post-activity/Post_activityshared.entity";
import { UserPointsEntity } from "../post/user-points.entity";
import { EventFilesEntity } from "../event/event-files.entity";
import { EventRSVPEntity } from "../event/event-rsvp.entity";
import { NotificationsEntity } from "../notifications/notifications.entity";
import { FeedBackEntity } from "../feedback/feedback.entity";
import { IdeaEntity } from "../idea/idea.entity";
import { IdeaActivityEntity } from "../idea/idea-activity.entity";
import { ComplaintEntity } from "../complaint/complaint.entity";
import { NoteEntity } from "../notes/note.entity";
import { NoteActivityEntity } from "../notes/note-activity.entity";
import { AppointmentEntity } from "../appointment/appointment.entity";
import { PostJobsEntity } from "../post/jobs.entity";

@Entity('user')
export class UserEntity { 

    @PrimaryGeneratedColumn('increment',{name:'id'}) 
    Id: number;
    @Column("varchar",{
        nullable:true,
        length:500,
        name:"membership_id"
    })
    membershipId:string;
    @Column("varchar",{
        nullable:false,
        length:10,
        name:"mobile_no"
    })
    mobileNo:string;
    @Column("boolean",{
        nullable:false,
        default:false,
        name:"is_pin_set"
    })
    isPinSet:boolean;
    @Column("varchar",{
        nullable:true,
        length:500,
        name:"pin"
    })
    pin?:string;
    @Column("int",{
        nullable: true,
        name:"role_id"
    })
    roleId:number;
    @Column("int",{
        nullable: true,
        name:"hierarchy_id"
    })
    hierarchyId:number;
    @Column("varchar",{
        nullable:true,
        length:500,
        name:"fcm_token"
    })
    fcmToken:string;
    @Column("boolean",{
        nullable:false,
        default:true,               
        name:"status"
    })
    status:boolean;
    @Column({
        nullable:true,
        name: "last_login",
        type:'datetime'
    })
    lastLogin: Date;
    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
    })
    createdAt: Date;
    @Column("int", {
        nullable: true,
        name: "created_user"
    })
    createdUser: number | null;
    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;
    @Column("int", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: number | null;
    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;
    @BeforeInsert()  
    @BeforeUpdate()
    async hashPassword() {
        if(this.pin){
            this.pin = await bcrypt.hash(this.pin, 10);  
        }
    }    
    @ManyToOne(() => RolesEntity, (roles: RolesEntity) => roles.user)
    @JoinColumn({ name: 'role_id' })
    roles: RolesEntity;
    @ManyToOne(() => HierarchyEntity, (hierarchy: HierarchyEntity) => hierarchy.user)
    @JoinColumn({ name: 'hierarchy_id' })
    hierarchy: HierarchyEntity; 
    @OneToOne(() => ProfileEntity, (profile: ProfileEntity) => profile.user)
    profile: ProfileEntity; 
    @OneToOne(() => UserPointsEntity, (userpoints: UserPointsEntity) => userpoints.user)
    userpoints: UserPointsEntity;
    @OneToMany(() => PostEntity, (post:PostEntity) => post.user)
    post:PostEntity; 
    @OneToMany(() => PostFilesEntity, (postfiles: PostFilesEntity)=> postfiles.user)
    postfiles: PostFilesEntity;
    @OneToMany(() => PollEntity,(poll:PollEntity)=>poll.user)
    poll:PollEntity;
    @OneToMany(() => PostActivityEntity, (postactivity: PostActivityEntity) => postactivity.user)
    postactivity: PostActivityEntity;    
    @OneToMany(() => CommmentsEntity, (comments: CommmentsEntity) => comments.user)
    comments: CommmentsEntity;
    @OneToMany(()=> ReportEntity, (report:ReportEntity)=>report.user)
    report:ReportEntity;
    @OneToMany(()=> WelfareEntity, (welfare:WelfareEntity)=>welfare.user)
    welfare:WelfareEntity;
    @OneToMany(()=> WelfareStatusEntity, (welfarestatus:WelfareStatusEntity)=>welfarestatus.user)
    welfarestatus:WelfareStatusEntity;
    @OneToMany(()=> RepresentationEntity, (representation:RepresentationEntity)=>representation.user)
    representation:RepresentationEntity;
    @OneToMany(()=>EventsEntity, (event:EventsEntity)=>event.user)
    event:EventsEntity;
    @OneToMany(()=>EventDetailsEntity, (eventdetails:EventDetailsEntity)=>eventdetails.user)
    eventdetails:EventDetailsEntity;
    @OneToMany(()=>EventFilesEntity,(eventfiles:EventFilesEntity)=>eventfiles.user)
    eventfiles:EventFilesEntity;
    @OneToMany(()=>EventRSVPEntity,(eventrsvp:EventRSVPEntity)=>eventrsvp.user)
    eventrsvp:EventRSVPEntity;
    @OneToMany(() => PollVotingEntity, (pollvoting: PollVotingEntity) => pollvoting.user)
    pollvoting:PollVotingEntity;
    @OneToMany(()=>PostPointsEntity,(postpoints:PostPointsEntity)=>postpoints.user)
    postpoints:PostPointsEntity;       
    @OneToMany(() => PostActivitySharedEntity, (postactivitysharedby: PostActivitySharedEntity) => postactivitysharedby.sharedby)
    postactivitysharedby: PostActivitySharedEntity;
    @OneToMany(() => PostActivitySharedEntity, (postactivitysharedwith: PostActivitySharedEntity) => postactivitysharedwith.sharedwith)
    postactivitysharedwith: PostActivitySharedEntity;
    @OneToMany(() =>NotificationsEntity, (notify:NotificationsEntity)=>notify.user)
    notify:NotificationsEntity;
    @OneToMany(() => FeedBackEntity,(feedback:FeedBackEntity)=>feedback.user)
    feedback:FeedBackEntity;
    @OneToMany(() => IdeaEntity,(idea:IdeaEntity)=>idea.user)
    idea:IdeaEntity;
    @OneToMany(() => IdeaActivityEntity,(ideactivity:IdeaActivityEntity)=>ideactivity.user)
    ideactivity:IdeaActivityEntity;
    @OneToMany(() => NoteEntity,(note:NoteEntity)=>note.user)
    note:NoteEntity;
    @OneToMany(() => NoteActivityEntity,(noteactivity:NoteActivityEntity)=>noteactivity.user)
    noteactivity:NoteActivityEntity;
    @OneToMany(() => ComplaintEntity,(complaint:ComplaintEntity)=>complaint.user)
    complaint:ComplaintEntity;
    @OneToMany(() => AppointmentEntity, (appnts: AppointmentEntity) => appnts.user)
    appnts: AppointmentEntity;

    @OneToMany(() => PostJobsEntity, (postjobs: PostJobsEntity) => postjobs.user)
    postjobs: PostJobsEntity;
}